import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { useModal } from '../../../../hooks/Modal';
import { usePickup } from '../../../../hooks/Pickup';
import { ProfileCollectContext } from '../..';
import { ModalTitle, ModalText } from './styled';

export const ModalDisclaimerForDamages = () => {
  const { closeModal, Modal } = useModal();
  const { enableCheckList } = usePickup();

  const { setRadio } = useContext(ProfileCollectContext);

  const history = useHistory();

  const handleConfirmTerms = () => {
    closeModal();
    history.push('/acesso-rapido/tipo-de-solicitante');
  };

  const handleCloseModal = () => {
    setRadio('');
    closeModal();
  };

  return (
    <Modal closeFunction={handleCloseModal}>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          maxHeight: '86vh',
          overflow: 'auto'
        }}
      >
        <ModalTitle>
          Termo de Isenção de Responsabilidade por Avarias (Embalagens)
        </ModalTitle>

        <ModalText>
          Declaro para os devidos fins de direito, que a mercadoria entregue a
          transporte estará devidamente acondicionada em embalagem de qualidade
          e suficiente para suportar embarque, desembarque e manuseio dos
          produtos durante a operação de transporte.
        </ModalText>

        <ModalText style={{ marginTop: 8 }}>
          Estou ciente que a inadequação da embalagem é causa excludente de
          responsabilidade do transportador em caso de avaria das mercadorias.
        </ModalText>

        {enableCheckList && (
          <>
            <ModalText style={{ marginTop: 8, fontWeight: 'bold' }}>
              Para consultar as Orientações Gerais de Transporte:
            </ModalText>

            <Link
              data-testid="openGeneralShippingGuidelinesLink"
              to="/acesso-rapido/orientacoes-gerais-de-transporte"
              style={{ alignSelf: 'center' }}
            >
              Clique aqui
            </Link>
          </>
        )}

        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 16,
            marginTop: 16
          }}
        >
          <Button
            type="button"
            variant="contained"
            color="secondary"
            data-testid="cancelDisclaimerForDamagesModalButton"
            onClick={handleCloseModal}
          >
            Cancelar
          </Button>
          <Button
            type="button"
            variant="contained"
            data-testid="acceptDisclaimerForDamagesModalButton"
            onClick={handleConfirmTerms}
          >
            Aceitar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
